/**
 * Utility untuk identifikasi dan manajemen sesi perangkat (Office Team)
 */

const DEVICE_ID_KEY = "satala_office_device_id";
const DEVICE_NAME_KEY = "satala_office_device_name";
const LOGIN_AT_KEY = "satala_office_login_at";

export function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = "dev_" + Date.now().toString(36) + "_" + Math.random().toString(36).substring(2, 9);
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return "dev_fallback_" + Date.now();
  }
}

export function detectOS() {
  if (typeof window === "undefined" || !navigator) return "Unknown OS";
  const ua = navigator.userAgent;
  if (/windows phone/i.test(ua)) return "Windows Phone";
  if (/win/i.test(ua)) return "Windows";
  if (/android/i.test(ua)) return "Android";
  if (/ipad|iphone|ipod/i.test(ua)) return "iOS";
  if (/mac/i.test(ua)) return "macOS";
  if (/linux/i.test(ua)) return "Linux";
  return "Unknown OS";
}

export function detectBrowser() {
  if (typeof window === "undefined" || !navigator) return "Browser";
  const ua = navigator.userAgent;
  if (/edg/i.test(ua)) return "Edge";
  if (/opr\//i.test(ua) || /opera/i.test(ua)) return "Opera";
  if (/chrome|crios/i.test(ua)) return "Chrome";
  if (/firefox|fxios/i.test(ua)) return "Firefox";
  if (/safari/i.test(ua)) return "Safari";
  return "Browser";
}

export function detectDeviceType() {
  if (typeof window === "undefined" || !navigator) return "desktop";
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) return "tablet";
  if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/i.test(ua)) {
    return "mobile";
  }
  return "desktop";
}

export function getDeviceName() {
  try {
    const custom = localStorage.getItem(DEVICE_NAME_KEY);
    if (custom && custom.trim()) return custom.trim();
  } catch {}

  const os = detectOS();
  const browser = detectBrowser();
  const type = detectDeviceType();

  if (type === "mobile") {
    return `${os} Mobile · ${browser}`;
  }
  if (type === "tablet") {
    return `${os} Tablet · ${browser}`;
  }
  return `${os} PC · ${browser}`;
}

export function setCustomDeviceName(name) {
  try {
    if (name && name.trim()) {
      localStorage.setItem(DEVICE_NAME_KEY, name.trim());
    } else {
      localStorage.removeItem(DEVICE_NAME_KEY);
    }
  } catch {}
}

export function getLoginAt() {
  try {
    let loginAt = localStorage.getItem(LOGIN_AT_KEY);
    if (!loginAt) {
      loginAt = new Date().toISOString();
      localStorage.setItem(LOGIN_AT_KEY, loginAt);
    }
    return loginAt;
  } catch {
    return new Date().toISOString();
  }
}

export function getCurrentDeviceInfo() {
  return {
    device_id: getDeviceId(),
    device_name: getDeviceName(),
    os: detectOS(),
    browser: detectBrowser(),
    device_type: detectDeviceType(),
    login_at: getLoginAt(),
    last_active: new Date().toISOString(),
  };
}

/**
 * Merge & sinkronisasi sesi perangkat saat ini ke dalam daftar active_sessions.
 * Menghapus sesi mati yang tidak aktif lebih dari 30 hari.
 */
export function syncActiveSessions(existingSessions = [], currentInfo = getCurrentDeviceInfo()) {
  const now = Date.now();
  const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

  let list = Array.isArray(existingSessions) ? [...existingSessions] : [];

  // Filter out session yang sudah expired > 30 hari
  list = list.filter((s) => {
    if (!s || !s.device_id) return false;
    const lastActive = s.last_active ? new Date(s.last_active).getTime() : 0;
    return now - lastActive < THIRTY_DAYS_MS;
  });

  const existingIdx = list.findIndex((s) => s.device_id === currentInfo.device_id);
  if (existingIdx >= 0) {
    // Pertahankan nama kustom jika ada di remote atau local
    const mergedName = currentInfo.device_name || list[existingIdx].device_name;
    list[existingIdx] = {
      ...list[existingIdx],
      ...currentInfo,
      device_name: mergedName,
      last_active: new Date().toISOString(),
    };
  } else {
    list.unshift({
      ...currentInfo,
      last_active: new Date().toISOString(),
    });
  }

  return list;
}
